import React from 'react';
import { PasswordHideIcon, PasswordShowIcon } from '../../assets';

interface PasswordInputProps {
    formik?: any;
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: string;
    touched?: boolean;
    passwordVisible: boolean;
    togglePasswordVisibility: () => void;
    placeholder?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    error,
    touched,
    passwordVisible,
    togglePasswordVisibility,
    placeholder,
}) => {
    return (
        <div className="form-group" style={{ position: 'relative' }}>
            <label className="form-label">
                {label} <span className="required-dot">*</span>
            </label>
            <input
                type={passwordVisible ? 'text' : 'password'}
                className="form-control"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                name={name}
            />
            <span
                onClick={togglePasswordVisibility}
                style={{ position: 'absolute', right: 10, top: 38, cursor: 'pointer' }}
            >
                <img src={passwordVisible ? PasswordHideIcon : PasswordShowIcon} alt='icon' />
            </span>
            {touched && error ? <div className="error-msg">{error}</div> : null}
        </div>
    );
};

export default PasswordInput; 